import React from 'react';
import { injectIntl } from 'react-intl';
import { InputSC, TInputSC } from './input.styled';
import Error from '../error';
import { StyledComponent } from 'styled-components';

type TProps = {
  label?: string | React.ReactNode;
  type?: string;
  placeholder?: string;
  required?: boolean;
  mb?: number;
  error?: string | boolean;
  inputStyle?: object;
  intl: any;
  asteriskSpace?: boolean;
  customInputStyledComponent?: StyledComponent<'div', any, TInputSC, never>;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input: React.FC<TProps> = ({
  label,
  placeholder,
  required,
  intl,
  mb,
  error,
  inputStyle,
  asteriskSpace,
  customInputStyledComponent,
  ...props
}) => {
  const WrapperComponent = customInputStyledComponent || InputSC;
  return (
    <WrapperComponent mb={mb} error={error}>
      <div className="input-wrapper">
        <input
          {...props}
          autoComplete="off"
          style={inputStyle}
          placeholder={placeholder ? intl.formatMessage({ id: placeholder }) : ''}
        />
        <div>
          <label>
            {required ? '*' : ''}
            {asteriskSpace && ' '}
            {label}
          </label>
        </div>
      </div>
      {<Error message={error} />}
    </WrapperComponent>
  );
};

Input.defaultProps = {
  type: 'text',
  mb: 8,
};

// @ts-ignore
export default injectIntl(Input);
